// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Referencia: nuevo_front/css/conciliacion-documentos.css (layout side-by-side) */

.orphan_invoices_pageHeader__I03FX {
    margin-bottom: 1.25rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #e5e7eb;
}

.orphan_invoices_pageTitle__MO-EQ {
    font-size: 1.5rem;
    font-weight: 700;
    color: #111827;
    margin: 0 0 0.25rem 0;
    letter-spacing: -0.02em;
}

.orphan_invoices_pageSubtitle__7JzT5 {
    margin: 0;
    font-size: 0.875rem;
    color: #6b7280;
    max-width: 48rem;
    line-height: 1.45;
}

.orphan_invoices_conciliacionLayout__5OL9E {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.25rem;
    align-items: start;
    margin-top: 1rem;
    margin-bottom: 2rem;
}

@media (max-width: 1200px) {
    .orphan_invoices_conciliacionLayout__5OL9E {
        grid-template-columns: 1fr;
    }
}

.orphan_invoices_panelConciliacion__iqUu6 {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    border: 1px solid #e5e7eb;
    display: flex;
    flex-direction: column;
    min-height: 560px;
    height: 100%;
}

.orphan_invoices_panelHeader__s1vwf {
    padding: 1rem 1.25rem;
    border-bottom: 1px solid #e5e7eb;
    background: #fafafa;
    border-radius: 12px 12px 0 0;
}

.orphan_invoices_panelTitle__n3DBN {
    font-size: 1rem;
    font-weight: 700;
    color: #111827;
    margin: 0 0 4px 0;
    display: flex;
    align-items: center;
    gap: 8px;
}

.orphan_invoices_panelIcon__ZWt3- {
    color: #4b5563;
    font-size: 0.95rem;
}

.orphan_invoices_panelSubtitle__uWWMO {
    font-size: 0.75rem;
    color: #6b7280;
    font-weight: 500;
    margin: 0 0 0.75rem 0;
}

.orphan_invoices_searchGroup__lgtms {
    display: flex;
    align-items: stretch;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
}

.orphan_invoices_searchPrefix__eoVqf {
    display: flex;
    align-items: center;
    padding: 0 0.65rem;
    color: #9ca3af;
    border-right: 1px solid #e5e7eb;
    background: #fff;
}

.orphan_invoices_searchInput__HcuCu {
    flex: 1 1;
    border: none;
    padding: 0.4rem 0.65rem;
    font-size: 0.875rem;
    outline: none;
}

.orphan_invoices_searchInput__HcuCu::placeholder {
    color: #9ca3af;
}

.orphan_invoices_panelBody__l4eaT {
    padding: 0.75rem;
    flex: 1 1;
    overflow-y: auto;
    max-height: min(62vh, 700px);
    background: #fff;
    border-radius: 0 0 12px 12px;
}

.orphan_invoices_panelFooter__MKatj {
    padding: 0.5rem 0.75rem 0.75rem;
    border-top: 1px solid #f3f4f6;
    background: #fff;
    border-radius: 0 0 12px 12px;
}

.orphan_invoices_emptyPanel__Qud-- {
    padding: 1.5rem;
    text-align: center;
    color: #6b7280;
    font-size: 0.875rem;
}

.orphan_invoices_itemFactura__J57r2[draggable="true"] {
    cursor: grab;
}

.orphan_invoices_itemFactura__J57r2[draggable="true"]:active {
    cursor: grabbing;
}

.orphan_invoices_itemFactura__J57r2,
.orphan_invoices_itemOc__UgHbu {
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 0.75rem 1rem;
    margin-bottom: 0.65rem;
    transition: border-color 0.15s, box-shadow 0.15s;
}

.orphan_invoices_itemFactura__J57r2:hover,
.orphan_invoices_itemOc__UgHbu:hover {
    background: #fff;
    border-color: #c7d2fe;
    box-shadow: 0 1px 4px rgba(99, 102, 241, 0.12);
}

.orphan_invoices_itemOcDropTarget__CaACg {
    outline: 2px solid #6366f1;
    background: #eef2ff;
    border-color: #a5b4fc;
}

.orphan_invoices_itemHeader__2u1oM {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.5rem;
    margin-bottom: 0.35rem;
}

.orphan_invoices_itemNumero__sxrX8 {
    font-size: 0.9375rem;
    font-weight: 600;
    color: #111827;
}

.orphan_invoices_itemTipo__l4KW- {
    font-size: 0.7rem;
    padding: 2px 8px;
    border-radius: 4px;
    background: #e5e7eb;
    color: #4b5563;
    white-space: nowrap;
}

.orphan_invoices_itemMeta__llvER {
    font-size: 0.8rem;
    color: #6b7280;
    margin-bottom: 0.35rem;
    line-height: 1.35;
}

.orphan_invoices_itemDetalles__3QGgJ {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.8rem;
    color: #374151;
    margin-top: 0.4rem;
}

.orphan_invoices_pillAction__obZAs {
    cursor: pointer;
    font-size: 0.75rem;
    font-weight: 500;
    padding: 0.2rem 0.65rem;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    background: #fff;
    color: #111827;
}

.orphan_invoices_pillAction__obZAs:hover {
    border-color: #9ca3af;
}

.orphan_invoices_filtersCompact__R40Pw {
    margin-bottom: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/providers/orphan_invoices/orphan_invoices.module.css"],"names":[],"mappings":"AAAA,kFAAkF;;AAElF;IACI,sBAAsB;IACtB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yCAAyC;IACzC,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;IAChC,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,SAAO;IACP,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,+BAA+B;IAC/B,6BAA6B;IAC7B,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,gDAAgD;AACpD;;AAEA;;IAEI,gBAAgB;IAChB,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["/* Referencia: nuevo_front/css/conciliacion-documentos.css (layout side-by-side) */\n\n.pageHeader {\n    margin-bottom: 1.25rem;\n    padding-bottom: 1rem;\n    border-bottom: 1px solid #e5e7eb;\n}\n\n.pageTitle {\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 0.25rem 0;\n    letter-spacing: -0.02em;\n}\n\n.pageSubtitle {\n    margin: 0;\n    font-size: 0.875rem;\n    color: #6b7280;\n    max-width: 48rem;\n    line-height: 1.45;\n}\n\n.conciliacionLayout {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1.25rem;\n    align-items: start;\n    margin-top: 1rem;\n    margin-bottom: 2rem;\n}\n\n@media (max-width: 1200px) {\n    .conciliacionLayout {\n        grid-template-columns: 1fr;\n    }\n}\n\n.panelConciliacion {\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n    border: 1px solid #e5e7eb;\n    display: flex;\n    flex-direction: column;\n    min-height: 560px;\n    height: 100%;\n}\n\n.panelHeader {\n    padding: 1rem 1.25rem;\n    border-bottom: 1px solid #e5e7eb;\n    background: #fafafa;\n    border-radius: 12px 12px 0 0;\n}\n\n.panelTitle {\n    font-size: 1rem;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 4px 0;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.panelIcon {\n    color: #4b5563;\n    font-size: 0.95rem;\n}\n\n.panelSubtitle {\n    font-size: 0.75rem;\n    color: #6b7280;\n    font-weight: 500;\n    margin: 0 0 0.75rem 0;\n}\n\n.searchGroup {\n    display: flex;\n    align-items: stretch;\n    border: 1px solid #d1d5db;\n    border-radius: 8px;\n    overflow: hidden;\n    background: #fff;\n}\n\n.searchPrefix {\n    display: flex;\n    align-items: center;\n    padding: 0 0.65rem;\n    color: #9ca3af;\n    border-right: 1px solid #e5e7eb;\n    background: #fff;\n}\n\n.searchInput {\n    flex: 1;\n    border: none;\n    padding: 0.4rem 0.65rem;\n    font-size: 0.875rem;\n    outline: none;\n}\n\n.searchInput::placeholder {\n    color: #9ca3af;\n}\n\n.panelBody {\n    padding: 0.75rem;\n    flex: 1;\n    overflow-y: auto;\n    max-height: min(62vh, 700px);\n    background: #fff;\n    border-radius: 0 0 12px 12px;\n}\n\n.panelFooter {\n    padding: 0.5rem 0.75rem 0.75rem;\n    border-top: 1px solid #f3f4f6;\n    background: #fff;\n    border-radius: 0 0 12px 12px;\n}\n\n.emptyPanel {\n    padding: 1.5rem;\n    text-align: center;\n    color: #6b7280;\n    font-size: 0.875rem;\n}\n\n.itemFactura[draggable=\"true\"] {\n    cursor: grab;\n}\n\n.itemFactura[draggable=\"true\"]:active {\n    cursor: grabbing;\n}\n\n.itemFactura,\n.itemOc {\n    background: #f9fafb;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    padding: 0.75rem 1rem;\n    margin-bottom: 0.65rem;\n    transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.itemFactura:hover,\n.itemOc:hover {\n    background: #fff;\n    border-color: #c7d2fe;\n    box-shadow: 0 1px 4px rgba(99, 102, 241, 0.12);\n}\n\n.itemOcDropTarget {\n    outline: 2px solid #6366f1;\n    background: #eef2ff;\n    border-color: #a5b4fc;\n}\n\n.itemHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 0.5rem;\n    margin-bottom: 0.35rem;\n}\n\n.itemNumero {\n    font-size: 0.9375rem;\n    font-weight: 600;\n    color: #111827;\n}\n\n.itemTipo {\n    font-size: 0.7rem;\n    padding: 2px 8px;\n    border-radius: 4px;\n    background: #e5e7eb;\n    color: #4b5563;\n    white-space: nowrap;\n}\n\n.itemMeta {\n    font-size: 0.8rem;\n    color: #6b7280;\n    margin-bottom: 0.35rem;\n    line-height: 1.35;\n}\n\n.itemDetalles {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 0.8rem;\n    color: #374151;\n    margin-top: 0.4rem;\n}\n\n.pillAction {\n    cursor: pointer;\n    font-size: 0.75rem;\n    font-weight: 500;\n    padding: 0.2rem 0.65rem;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    background: #fff;\n    color: #111827;\n}\n\n.pillAction:hover {\n    border-color: #9ca3af;\n}\n\n.filtersCompact {\n    margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeader": `orphan_invoices_pageHeader__I03FX`,
	"pageTitle": `orphan_invoices_pageTitle__MO-EQ`,
	"pageSubtitle": `orphan_invoices_pageSubtitle__7JzT5`,
	"conciliacionLayout": `orphan_invoices_conciliacionLayout__5OL9E`,
	"panelConciliacion": `orphan_invoices_panelConciliacion__iqUu6`,
	"panelHeader": `orphan_invoices_panelHeader__s1vwf`,
	"panelTitle": `orphan_invoices_panelTitle__n3DBN`,
	"panelIcon": `orphan_invoices_panelIcon__ZWt3-`,
	"panelSubtitle": `orphan_invoices_panelSubtitle__uWWMO`,
	"searchGroup": `orphan_invoices_searchGroup__lgtms`,
	"searchPrefix": `orphan_invoices_searchPrefix__eoVqf`,
	"searchInput": `orphan_invoices_searchInput__HcuCu`,
	"panelBody": `orphan_invoices_panelBody__l4eaT`,
	"panelFooter": `orphan_invoices_panelFooter__MKatj`,
	"emptyPanel": `orphan_invoices_emptyPanel__Qud--`,
	"itemFactura": `orphan_invoices_itemFactura__J57r2`,
	"itemOc": `orphan_invoices_itemOc__UgHbu`,
	"itemOcDropTarget": `orphan_invoices_itemOcDropTarget__CaACg`,
	"itemHeader": `orphan_invoices_itemHeader__2u1oM`,
	"itemNumero": `orphan_invoices_itemNumero__sxrX8`,
	"itemTipo": `orphan_invoices_itemTipo__l4KW-`,
	"itemMeta": `orphan_invoices_itemMeta__llvER`,
	"itemDetalles": `orphan_invoices_itemDetalles__3QGgJ`,
	"pillAction": `orphan_invoices_pillAction__obZAs`,
	"filtersCompact": `orphan_invoices_filtersCompact__R40Pw`
};
export default ___CSS_LOADER_EXPORT___;
